import React from 'react';
import './Banner.css'

const Banner = () => {
  return (
    <div className='banner'>
      <div className='text-light  text-center w-50 mx-auto'>
        <h1>Smart life, Smart solution. <br /> Success Guaranteed</h1>
      </div>
    </div>
  );
};

export default Banner;